import { Box, Typography } from '@mui/material';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import roomImage from 'src/assets/png/hos-room.png';
import { ReactComponent as LogoHos } from 'src/assets/svg/hos-square-logo.svg';

import { styles } from './styles';

export const HosSuccessPage: FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <Box css={styles.container}>
            <Box css={styles.topWrapper}>
                <img src={roomImage} alt="room" css={styles.image} />
                <Box css={styles.titleWrapper}>
                    <Box css={styles.circle} />
                    <Typography variant="h1" css={styles.title}>
                        {t('hos_success_title')}
                    </Typography>
                </Box>
                <Typography
                    variant="body3"
                    align="center"
                    dangerouslySetInnerHTML={{ __html: t('hos_success_content') }}
                />
            </Box>

            <Box css={styles.bottomWrapper}>
                <LogoHos css={styles.logo} />
            </Box>
        </Box>
    );
};
